var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-switch',{staticClass:"mt-2",attrs:{"label":"Hourly price notifications"},on:{"change":_vm.onToggleNotification},model:{value:(_vm.receivedNotifications.status.status),callback:function ($$v) {_vm.$set(_vm.receivedNotifications.status, "status", $$v)},expression:"receivedNotifications.status.status"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }